import React from "react";
import Linebreak from "@/components/linebreak";
import ItemMobileView from "@/components/create-shipment-form/item-mobile-view";
import Item from "@/components/create-shipment-form/item";
import AddButton from "@/components/add-button";
import { validateInput } from "@/components/create-shipment-form/form-w-validation";

export default function ItemList({
  itemsList,
  parcel,
  packageIndex,
  updatePackage,
  packingType,
  setItemValueUpdateCounter,
  showWeight = true,
  disabled,
}) {
  const headerGridColsClass = showWeight
    ? "grid-cols-[38px_auto_18%_15%_15.5%]"
    : "grid-cols-[38px_auto_25%_20%]";

  const handleQuantityChange = (index, value) => {
    validateInput("number", value, (validValue) => {
      updatePackage("item", { quantity: validValue }, packageIndex, index);
    });
  };

  const handleDescriptionChange = (index, value) => {
    updatePackage("item", { description: value }, packageIndex, index);
  };

  const handleCategoryChange = (index, value) => {
    updatePackage("item", { category: value }, packageIndex, index);
  };

  const handleTotalValueChange = (index, value) => {
    validateInput("float", value, (validValue) => {
      updatePackage(
        "item",
        { validTotalValue: validValue >= 1, totalValue: validValue },
        packageIndex,
        index
      );
      setItemValueUpdateCounter((prev) => prev + 1);
    });
  };

  const handleTotalWeightChange = (index, value) => {
    validateInput("float", value, (validValue) => {
      updatePackage("item", { totalWeight: validValue }, packageIndex, index);
      if (validValue > 0) {
        updatePackage("item", { validTotalWeight: true }, packageIndex, index);
      }
    });
  };

  const handleFragileChange = (index, value) => {
    updatePackage("item", { isFragile: value }, packageIndex, index);
  };

  const handleRemoveItem = (index) => {
    updatePackage("removeItem", null, packageIndex, index);
  };

  const handleValidityChange = (index, field, value) => {
    updatePackage("item", { [field]: value }, packageIndex, index);
  };

  const getItemProps = (index, itemObj, deviceType = "desktop") => ({
    itemIndex: index,
    itemObj,
    parcel,
    packageIndex,
    onQuantityChange: (value) => handleQuantityChange(index, value),
    onDescriptionChange: (value) => handleDescriptionChange(index, value),
    onCategoryChange: (value) => handleCategoryChange(index, value),
    onTotalValueChange: (value) => handleTotalValueChange(index, value),
    onTotalWeightChange: (value) => handleTotalWeightChange(index, value),
    onFragileChange: (value) => handleFragileChange(index, value),
    onRemoveItem: () => handleRemoveItem(index),
    onValidityChange: (field, value) =>
      handleValidityChange(index, field, value),
    packingType,
    showWeight,
    deviceTypePrefix: deviceType,
    disabled,
  });

  return (
    <>
      <div className="md:hidden md:pointer-events-none mt-8">
        {itemsList.map((itemObj, index) => (
          <div key={itemObj.key || index}>
            {index > 0 ? <Linebreak className="my-6" /> : null}
            <ItemMobileView {...getItemProps(index, itemObj, "mobile")} />
          </div>
        ))}
      </div>
      <div className="px-8 hidden pointer-events-none md:block md:pointer-events-auto">
        <div className={`grid ${headerGridColsClass} gap-x-1.5 mt-4 pl-1`}>
          <p>Qty</p>
          <p>
            Item Description
            <span className="text-vsm ml-1">
              (
              <a
                href="https://support.justship.sg/en/article/how-do-i-describe-my-item-when-filling-out-the-shipment-form-9klji5/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Get help with item description"
                className="text-light-purple hover:text-dark-purple hover:underline"
              >
                Need help?
              </a>
              )
            </span>
          </p>

          <p>Category</p>
          <p>Total Value</p>
          {showWeight && <p>Total Weight</p>}
        </div>
        {itemsList.map((itemObj, index) => (
          <Item
            key={itemObj.key}
            {...getItemProps(index, itemObj, "desktop")}
          />
        ))}
      </div>
      <div className="mt-4 md:mt-0 px-6 md:px-8">
        <AddButton
          className="md:h-9"
          onClick={() => updatePackage("addItem", null, packageIndex)}
          disabled={disabled}
        >
          Add Item
        </AddButton>
      </div>
    </>
  );
}
